<template>
  <button
    class="fixed-bottom-left-button"
    :class="`fixed-bottom-left-button--${color}`"
    v-on="$listeners">
    <span
      class="material-icons fixed-bottom-left-button__icon"
      :class="{ 'fixed-bottom-left-button__icon--large': largeIcon }">{{ icon }}</span>
    <slot />
  </button>
</template>

<script>
/**
 * @description FixedBottomLeftArea の中に置く小さめの固定ボタン
 */
export default {
  props: {
    // material-icons のアイコン名
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'blue',
      validator: (value) => ['blue', 'grey'].includes(value),
    },
    // アイコンを一回り大きくする。何のボタンか分かりにくいものにだけ付ける（先方依頼 #655）
    largeIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
// アイコンを大きくしてもラベルの位置が動かないよう、占有サイズは常にこの値にする
$icon-box-size: 15px;

.fixed-bottom-left-button {
  color: $white;
  font-weight: bold;
  font-size: $fs-s;
  border-width: 2px;
  border-style: solid;
  border-radius: 6px;
  padding: 5px 10px;
  box-shadow: 1px 2px 6px $grey05;

  &__icon {
    // グリフが占有する枠は固定し、font-size を変えても中心から左右・上下へ食み出させる。
    // こうしないと大きくした分だけラベルが右下へ押し出される
    display: inline-block;
    width: $icon-box-size;
    font-size: $icon-box-size;
    // material-icons の line-height: 1 は行の高さを押し広げるため行送りに参加させない
    line-height: 0;
    text-align: center;
    vertical-align: middle;

    &--large {
      font-size: 17px;
    }
  }

  &--blue {
    background-color: $l-blue;
    border-color: $l-blue;

    &:hover {
      background-color: darken($l-blue, 5%);
    }
  }

  &--grey {
    background-color: $grey12;
    border-color: $grey12;

    &:hover {
      background-color: darken($grey12, 5%);
    }
  }
}
</style>
